import { render, staticRenderFns } from "./ForgottenPasswordPage.vue?vue&type=template&id=e57f6cbe&"
import script from "./ForgottenPasswordPage.vue?vue&type=script&lang=js&"
export * from "./ForgottenPasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./ForgottenPasswordPage.vue?vue&type=style&index=0&id=e57f6cbe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports